export default __webpack_public_path__ + "static/media/979.5c747fea.gif";